// extracted by mini-css-extract-plugin
export var deleteModal = "_rf-0";